const en = {
  button: {
    admissions: 'Admissions',
    apply: 'Apply',
    notes: 'Notes',
    back: 'Back',
    curatedTour: 'Recommended Tours',
    exploreCampus: 'Explore Near Me',
    personalizedTour: 'Personalized Tour',
    home: 'Home',
    requestInfo: 'Request Info',
    search: 'Search',
    langSpanish: 'View in Spanish',
    langEnglish: 'View in English',
    langFrench: 'View in French',
    langKorean: 'View in Korean',
    langChineseMandarin: 'View in Chinese',
    continue: 'Continue',
    cancel: 'Cancel',
    resume: 'Resume',
    ok: 'Ok',
    emailMyTour: 'Email My Tour',
    emailMyNotes: 'Email My Notes',
    share: 'Share',
    finishTour: 'Finish Tour',
    edit: 'Edit',
    add: 'Add',
    save: 'Save'
  },
  message: {
    tourTheCampus: 'Tour the Campus',
    exploreCampus: '@:button.exploreCampus',
    notFound: 'Not Found',
    personalizedTour: '@:button.personalizedTour',
    curatedTour: '@:button.curatedTour',
    nothingError: 'Nothing to display',
    viewNotes: 'My Notes',
    continueAbandonedTour: 'Resume previous tour?',
    about: 'About',
    location: 'Location | Locations',
    locations: 'Locations',
    stops: 'Stops',
    congratulations: 'Congratulations!',
    firstName: 'First Name',
    lastName: 'Last Name',
    success: 'Success',
    listenNow: 'Listen Now',
    restrictedPublicAccess: 'Restricted Public Access',
    locationUnknown: 'It seems we can\'t locate you, possibly because you need to enable location services, so using a default location.',
    locationTooFar: 'It seems you\'re not near campus at the moment, so using a default location.'
  },
  socialMedia: {
    twitter: 'Twitter',
    facebook: 'Facebook',
    email: 'Email',
    text: 'SMS/Text'
  },
  curatedTour: {
    description1: 'We\'ve put together a list of the most common types of campus tours for you to experience',
    description2: 'Select an interest below and you will see a list of buildings related to that interest to tour',
    startTour: 'Start Tour',
    saveTour: 'Save Tour',
    viewRoute: 'View Route'
  },
  personalizedTour: {
    title: 'Personalize Your Tour',
    description1: 'Create your own campus tour by selecting Places of Interest based on your interests.',
    description2: 'Select a category below to start building your Personalized Tour.',
    description3: 'Add each Place of Interest to your list, then select "Create Tour".',
    poiSelected: 'Points of Interests Selected',
    createTour: 'Create Tour',
    editList: 'Edit List',
    personalizeTour: '@:personalizedTour.title',
    personalizedTour: 'My Personalized Tour',
    createText1: 'Create your own campus tour by selecting Places of Interest based on your interests.',
    createText2: 'Add each place of interest them to your list, then select "Create Tour".',
    myTourText1: 'Here is the personalized list of buildings and facilities you\'ve selected.',
    myTourText2: 'View the building for more information or click the map icon for directions.',
    startTour: '@:curatedTour.startTour',
    saveTour: '@:curatedTour.saveTour',
    viewRoute: '@:curatedTour.viewRoute',
    success: '@:message.success',
    firstName: '@:message.firstName',
    lastName: '@:message.lastName',
    tourEmailed: 'Your tour have been emailed.'
  },
  exploreCampus: {
    description1: 'Tour the campus and find the most common areas for students including common areas, cafeteria, stadium, dormitories and more',
    description2: 'View the building for more information or click the map icon for directions.',
    listView: 'List View',
    mapView: 'Map View'
  },
  notes: {
    title: '@:message.viewNotes',
    description: 'A collection of your notes during your tours. You can view or share via email.',
    success: '@:message.success',
    notesEmailed: 'Your notes have been emailed.',
    firstName: '@:message.firstName',
    lastName: '@:message.lastName',
    enterYourNoteHere: 'Enter your note here',
    edit: '@:button.edit',
    save: '@:button.save'
  },
  poiView: {
    description: 'Description',
    directions: 'Directions',
    notes: '@:button.notes',
    openMap: 'Map',
    startTour: 'Take me there',
    listStops: 'List stops',
    listEmpty: 'list is empty',
    priorStop: 'Prior Stop',
    nextStop: 'Next Stop'
  },
  about: {
    termSentence1: 'allows you to engage with campuses in a meaningful way - on your own terms.',
    termSentence2: 'View nearby buildings, take campus recommended tour or create your own personalized tour based on your unique interests.',
    createdPowered: 'Created and powered by'
  }
}

export default en
